"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultFilePaths = exports.NO_PREVIEW_FILE = exports.NOT_AVAILABLE_FILE = exports.BLANK_FILE = void 0;
var BLANK_FILE = 'blank';
exports.BLANK_FILE = BLANK_FILE;
var NO_PREVIEW_FILE = 'no-preview';
exports.NO_PREVIEW_FILE = NO_PREVIEW_FILE;
var NOT_AVAILABLE_FILE = 'not-available';
exports.NOT_AVAILABLE_FILE = NOT_AVAILABLE_FILE;
var defaultFilePaths = {
  blank: 'visualizer-blank.png',
  'no-preview': 'visualizer-nopreview.jpg',
  'not-available': 'visualizer-lp-notavailable.png'
};
exports.defaultFilePaths = defaultFilePaths;